module.exports = __webpack_public_path__ + "static/logo-dark-7f91ba725a9a766d22ad133a9a89e837.svg";